<template>
  <div class="ds-control ds-myschedule ds-no-padding" :style="myscheduleStyle">
    <div class="ds-myschedule-header" v-if="type == 'list'">
      <div class="ds-myschedule-tabs">
        <div
          v-for="(item, index) in scheduleTypeList"
          class="ds-myschedule-tab"
          :key="index"
          :class="{ active: type == item.value }"
          @click="changeType(item)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="ds-myschedule-main">
      <div class="ds-myschedule-main-content">
        <template v-if="type != 'list'">
          <DsfMyscheduleCalendar
            ref="calendarNav"
            :url="scheduleUrl"
            :holiday-url="holidayUrl"
            :type.sync="type"
            :user-ids="userIds"
            :my-tree-node="myTreeNode"
            :edit-path="editPath"
            :is-public-use="isPublicUse"
            :is-show-holiday="isShowHoliday"
            @changeType="changeType"
          ></DsfMyscheduleCalendar>
        </template>
        <template v-else>
          <DsfViewPart :path="listPath" :showModel="showModel"></DsfViewPart>
        </template>
      </div>
      <div
        class="ds-myschedule-main-user"
        v-if="type != 'list' && isPublicUse == true"
      >
        <DsfMyscheduleUser
          :user-path="userPath"
          :user-ids.sync="userIds"
          :my-tree-node="myTreeNode"
        ></DsfMyscheduleUser>
      </div>
    </div>
  </div>
</template>

<script>
const oneDay = 86400000;
export default dsf.component({
  name: "DsfMySchedule",
  mixins: [$mixins.control],
  ctrlCaption: "个人日程",
  design: {
    isMask: false,
  },
  props: {
    // 获取日程接口
    scheduleUrl: {
      type: String,
      default: "/agenda/info/queryFollowAgendaByDate",
    },
    // 跳转-人员选择
    userPath: {
      type: String,
      default: "pc/service/agenda/choose",
    },
    // 跳转-新增、查看
    editPath: {
      type: String,
      default: "pc/service/agenda/edit?type=0",
    },
    dataLoadedFun: {
      type: Function,
      required: false,
    },
    // 展示方式
    // day 日，week 周， month 月，list 列
    type: {
      type: String,
      default: "month",
    },
    // 列表设置
    listPath: {
      type: String,
      default: "/pc/service/agenda/joinlist?type=join",
    },
    showModel: {
      type: String,
      default: "full",
    },
    // 获取假日接口
    holidayUrl:{
      type: String,
      default: "/agenda/info/findHoliday",
    },
    // 是否显示假日
    isShowHoliday:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scheduleTypeList: [
        {
          text: "月",
          value: "month",
        },
        {
          text: "周",
          value: "week",
        },
        {
          text: "日",
          value: "day",
        },
        {
          text: "列",
          value: "list",
        },
      ],
      nowTime: dsf.date.format(new Date(), "yyyy-mm-dd"),
      userIds: "",
      // 虚拟固定节点
      myTreeNode: {
        label: "我",
        id: "myNodeId",
      },
      isPublicUse:
        window.$$serverConfig["setting_agenda_is_public_use"] == "0"
          ? false
          : true,
    };
  },
  computed: {
    myscheduleStyle() {
      if (this.isDesign) {
        return {
          "min-height": "500px",
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    type(v) {
      this.reloadData();
    },
    userIds(v) {
      this.reloadData();
    },
  },
  created() {
    this.reloadData();
  },
  methods: {
    reloadData() {
      this.$nextTick(() => {
        if (this.type != "list") {
          this.$refs.calendarNav.reloadData();
          this.setScroll();
        }
      });
    },
    changeType(e) {
      this.$emit("update:type", e.value);
    },

    // 设置滚动条
    async setScroll() {
      if (this.type != "month") {
        await this.$nextTick();
        let startTime = dsf.date.format(new Date(), "yyyy-mm-dd");
        let timeCha =
          dsf.date.parse(new Date()).getTime() -
          dsf.date.parse(startTime).getTime();
        let toTop = timeCha / 1000 / 60 / 60 / 24; // 滚动到百分比

        let scrollVm = this.$refs.calendarNav.$refs.scroll;
        let { scrollHeight, offsetHeight } = scrollVm.$box;
        let _toTop = (scrollHeight - offsetHeight) * toTop;
        scrollVm.scrollTo({
          top: _toTop,
        });
      }
    },
  },
});
</script>
